import { ModuleFE_DiseaseView } from './ModuleFE_DiseaseView.js';
export const ModulePackFE_DiseaseViewDB = [ModuleFE_DiseaseView];
//# sourceMappingURL=module-pack.js.map